
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const AboutPage = () => {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Navbar />
      <main className="flex-grow container mx-auto px-6 py-12">
        <div className="prose prose-gray dark:prose-invert lg:prose-xl max-w-4xl mx-auto bg-card p-8 rounded-lg shadow-lg">
          <h1 className="mb-6 text-4xl font-bold">About FAB</h1>
          <p className="text-lg">
            Welcome to <strong>FAB</strong> (short for Forms And Backup)! We are the <em>first and only</em> dedicated, automated backup solution
            designed specifically for forms metadata, i.e., field definitions, field layouts, conditional and hidden fields, mappings to a back-end database, all the characteristics that define your forms' structure.
          </p>
          <p>
            Online forms are an invaluable platform for data collection. However, without a robust and automatic backup system,
            your critical forms are vulnerable to accidental deletion, data corruption, or other unforeseen events.
            FAB was created to fill this crucial gap, providing peace of mind and safeguarding your vital work.
          </p>
          
          <h2 className="mt-10 mb-4 text-3xl font-semibold">Why We Built FAB</h2>
          <p>
            As users and developers deeply familiar with the online forms ecosystem, we experienced firsthand the anxiety
            that comes with managing important forms without a reliable safety net. We searched for comprehensive solutions but found
            nothing that specifically catered to form metadata's unique backup needs. So, we decided to build it ourselves.
          </p>
          <p>
            <strong>FAB</strong> is the solution we wished existed, meticulously crafted with the online forms community in mind. It's more than just software;
            it's our commitment to ensuring your data continuity.
          </p>

          <h2 className="mt-10 mb-4 text-3xl font-semibold">Our Core Commitment</h2>
          <p>At FAB, we are driven by a singular mission: to provide online forms users with unparalleled peace of mind through a secure, reliable, and easy-to-use backup service for your forms metadata.</p>
          <ul className="list-disc pl-5 space-y-2 mt-4">
            <li>
              <strong>Unwavering Security:</strong> Your data security is paramount. We employ industry-standard encryption and robust security practices
              to protect your form backups at all times.
            </li>
            <li>
              <strong>Steadfast Reliability:</strong> Our automated systems are engineered for dependability, ensuring your backups occur
              on schedule, every time, without fail.
            </li>
            <li>
              <strong>Effortless Simplicity:</strong> We believe backups should be easy, "set it and forget it" easy. FAB's platform is intuitive, requiring minimal setup
              so you can focus on your work, not on complex configurations.
            </li>
            <li>
              <strong>Dedicated Focus:</strong> We are 100% compatible with any listed forms providers. This means our solution is expertly tailored to their
              specific functionalities and the unique needs of its users. Unlike generic backup tools, FAB understands online forms.
            </li>
          </ul>
          <p className="mt-6">
            Thank you for considering or choosing <strong>FAB</strong>. We're excited to help you protect your vital forms data and empower you with
            the confidence that your hard work is always safe.
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default AboutPage;
